const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

const stringIsEmail = (value: string): boolean => {
  return EMAIL_REGEXP.test(value);
};

export default stringIsEmail;
